import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question:
      "How TekRevol is a considerable option as an app development company in Ohio",
    answer: `<p>Among mobile app development companies in Ohio, TekRevol outcasts the competitors with its highly functional mobile app solution. We are already the topmost choice of multiple businesses around the world and that’s great evidence for our credibility. By utilizing the premium technology stack and intuitive user interface, we provide a seamless experience that attracts users to any business. With our automation-based features using AI-driven innovations, we build an application that can revolutionize the functional procedure.</p>`,
  },
  {
    question: "Is there a high demand for mobile app developers in Ohio?",
    answer: `<p>The tech industry in Ohio is on the verge of potential growth as every business is focused on digitalization. Meanwhile, app development in Ohio is the right solution to have a solid online presence. That’s how you don’t connect to the customers with feasibility but also improvise the overall business</p>`,
  },
  {
    question: "What type of app is most profitable in Ohio?",
    answer: `<p>The profitability of a mobile app depends on the way you utilize the application and your objectives with the app. However, the mobile gaming industry is growing rapidly and many businesses are investing in gaming apps to earn the maximum profit. As Tekrevol specializes in game app development, we can build a stunning game with premium features while meeting the current gaming trends.</p>`,
  },
  {
    question: "How much does it cost to develop a mobile app in Ohio?",
    answer: ` <p>The overall expense of mobile app development in Ohio lies between $80k-$250k. However, it highly depends upon the requirements of the project and the technology stack you want to implement in your application. The scale of the app is another important factor on which the development cost depends.</p>
        <p>We facilitate our clients with different scopes of mobile application development by considering:</p>  
        <ul>
        <li>Native apps</li>
        <li>Cross-platform apps</li>
        <li>Hybrid apps</li>
    </ul>`,
  },
  {
    question: " Are mobile apps more profitable than websites in Ohio",
    answer: `<p>Although it depends on the business model you possess, as a factual statement a mobile app is proved to be more profitable than a website. There are plenty of reasons to justify this but the primary reason is the increasing usage of smartphones as it has become an integral part of our daily lives. With mobile apps, you can gain the maximum attention of the audience by keeping them well-connected with your business.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
